function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8C6CD"
    },
    d: "M391.059,129.92v82.577l-68.409-0.02v-79.957c0-16.977-7.459-32.345-19.527-43.473 c-12.058-11.128-28.726-18.007-47.133-18.007c-36.814,0-66.66,27.526-66.66,61.48v79.898h-68.409V129.92 C120.921,58.171,181.392,0,255.99,0S391.059,58.171,391.059,129.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEADB3"
    },
    d: "M391.059,129.92v82.577l-68.409-0.02v-79.957c0-16.977-7.459-32.345-19.527-43.473 c-12.058-11.128-28.726-18.007-47.133-18.007V0C330.588,0,391.059,58.171,391.059,129.92z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.254,
    y: 197.419,
    style: {
      fill: "#FDC000"
    },
    width: 375.491,
    height: 314.581
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.995,
    y: 197.419,
    style: {
      fill: "#D9A600"
    },
    width: 187.751,
    height: 314.581
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8900"
    },
    points: "341.247,322.72 255.99,412.066 247.101,421.384 180.262,364.833 199.629,341.937  244.912,380.231 255.99,368.622 319.55,302.013 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C06100"
    },
    points: "341.247,322.72 255.99,412.066 255.99,368.622 319.55,302.013 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.68fa22d7.svg";
export { ForwardRef as ReactComponent };